import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Subpartners } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Subpartners.Pages.SUBPARTNERS}`,
    name: Subpartners.Pages.SUBPARTNERS,
    component: () => import(/* webpackChunkName: "subpartners" */ './views/Subpartners.vue'),
    meta: {
      access_roles: RouteRoles[Subpartners.Pages.SUBPARTNERS],
    },
  },
  {
    path: `/${Subpartners.Pages.SUBPARTNER_DETAIL}/:id`,
    name: Subpartners.Pages.SUBPARTNER_DETAIL,
    component: () => import(/* webpackChunkName: "subpartner-detail" */ './views/SubpartnerDetail.vue'),
    meta: {
      access_roles: RouteRoles[Subpartners.Pages.SUBPARTNER_DETAIL],
    },
  },
  {
    path: `/${Subpartners.Pages.SUBPARTNER_DETAIL}/:id/edit`,
    name: Subpartners.Pages.SUBPARTNER_EDIT,
    component: () => import(/* webpackChunkName: "subpartner-edit" */ './views/SubpartnerEdit.vue'),
    meta: {
      access_roles: RouteRoles[Subpartners.Pages.SUBPARTNER_EDIT],
    },
  },
  {
    path: `/${Subpartners.Pages.SUBPARTNERS_SALES}`,
    name: Subpartners.Pages.SUBPARTNERS_SALES,
    component: () => import(/* webpackChunkName: "subpartners-sales" */ './views/SubpartnersSales.vue'),
    meta: {
      access_roles: RouteRoles[Subpartners.Pages.SUBPARTNERS_SALES],
    },
  },
];

export default routes;
